import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { distinctUntilChanged } from 'rxjs';
import {
  AppStateService,
  ConfigService,
  enLanguage,
  ErroMessages,
  IErroMessages,
  KEY_CREDENTIAIS,
  STATE,
  TOKEN_KEYS,
  TokenService,
  User,
  UserService,
  UserSettingsService
} from 'viggo-sistemas-core-web';
import build from '../../package.json';
import { KEY_NEW_VERSION, KEY_VERSION } from './app-components';
import { UpToDateBuildService } from './global services/build-services/up-to-date.service';
import { ConfirmDialogComponent, ConfirmDialogData } from './shared/components';
import { ValidadorSettingsUser } from './shared/utils/validar_settings_user';

@Component({
  selector: 'app-root',
  template: '<router-outlet #projectFrame></router-outlet>'
})
export class AppComponent implements OnInit {
  @ViewChild('projectFrame', { read: ElementRef }) projectFrame: ElementRef<
    HTMLElement
  >;
  public readonly appName = 'WoundCareSys';
  user?: User;

  public constructor(
    protected matDialog: MatDialog,
    protected matSnackBar: MatSnackBar,
    protected router: Router,
    protected userService: UserService,
    protected tokenService: TokenService,
    protected configService: ConfigService,
    private primengConfig: PrimeNGConfig,
    protected upToDateService: UpToDateBuildService,
    protected userSettingsService: UserSettingsService,
    protected appState: AppStateService
  ) {
    localStorage.setItem(TOKEN_KEYS.URL_API, configService.backendURL);
    localStorage.setItem(KEY_VERSION, build.version);
    this.user = this.tokenService.getUser();
    if (this.user) {
      this.user.settings = new ValidadorSettingsUser(
        this.user.settings,
        this.user.roles.find(rl => rl.name.toUpperCase() === 'SYSADMIN') !==
          undefined
      ).getUserSettingsBody(this.user.settings) as any;
    }
  }

  ngAfterViewInit(): void {
    this.upToDateService.buildIsUpToDate
      .pipe(distinctUntilChanged())
      .subscribe(buildIsUpToDate => {
        if (!buildIsUpToDate) {
          this.updateVersion();
        } else {
          localStorage.removeItem(KEY_NEW_VERSION);
        }
      });
  }

  public ngOnInit(): void {
    this.primengConfig.ripple = true;

    this.primengConfig.setTranslation(enLanguage.primeng);
  }

  public updateVersion() {
    if (!localStorage.getItem(KEY_NEW_VERSION)) {
      const dialog = this.matDialog.open(ConfirmDialogComponent, {
        data: {
          bodyMessage:
            'Parece que você está utilizando uma versão desatualizada! \n Deseja realizar atualização do sistema agora ou mais tarde?',
          title: 'Atualização do sistema',
          icon: 'pi pi-fw pi-refresh text-primary mr-2',
          icon_color: 'primary',
          labelCloseButton: 'Deixar para depois',
          labelConfirmButton: 'Atualizar agora',
          breakline: true
        } as ConfirmDialogData,
        disableClose: true,
        panelClass: ['custom-container'],
        width: '500px'
      });

      dialog.afterOpened().subscribe(() => {
        localStorage.setItem(KEY_NEW_VERSION, 'true');
      });

      dialog.afterClosed().subscribe(confirm => {
        if (confirm) {
          this.onLogOut();
        }
      });
    }
  }

  public onLogOut() {
    if (this.tokenService.isLoggedIn()) {
      this.user = this.tokenService.getUser() as User;
      this.user = {
        ...this.user,
        settings: {
          ...this.user.settings,
          primeiro_acesso: false,
          version: {
            ...this.user.settings['version'],
            web_version: localStorage.getItem(KEY_VERSION)
          }
        } as any
      };
      this.userSettingsService
        .update(this.user.settings, this.user.id)
        .subscribe(
          vl => {
            this.tokenService.onLogout().subscribe(
              () => {
                const credentials = localStorage.getItem(KEY_CREDENTIAIS);
                const URL_API = localStorage.getItem(TOKEN_KEYS.URL_API);
                localStorage.clear();
                localStorage.setItem(KEY_CREDENTIAIS, credentials);
                localStorage.setItem(TOKEN_KEYS.URL_API, URL_API);
                this.appState.setAppState(STATE.INITIALIZING);
                this.router.navigate(['/auth/login']);
              },
              (err: HttpErrorResponse) => {
                if (err && err.error) this.displayError(err);
              },
              () => {
                this.router.navigate(['/auth/login']).finally(() => {
                  if (!this.tokenService.isLoggedIn()) window.location.reload();
                });
              }
            );
          },
          (err: HttpErrorResponse) => {
            this.displayError(err);
          }
        );
    }
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.matDialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.checkError();
  }
}
